import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const DISCORD_URL = "https://discord.gg/FsFnn9NuF3";

export default function CTA() {
  return (
    <section
      id="contact"
      data-testid="cta-section"
      className="relative py-24 lg:py-28 border-t border-purple-500/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.21, 0.65, 0.35, 1] }}
          className="relative overflow-hidden rounded-3xl border border-purple-500/25 bg-[#11131f] px-6 py-16 sm:px-12 lg:px-20 text-center"
        >
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle at 50% 0%, rgba(147,51,234,0.25) 0%, rgba(9,10,15,0) 65%)",
            }}
          />
          <div className="absolute inset-0 grid-pattern opacity-60 pointer-events-none" />

          <div className="relative">
            <h2
              data-testid="cta-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight"
            >
              Ready to Build Something Great?
            </h2>
            <p
              data-testid="cta-text"
              className="mt-5 max-w-xl mx-auto text-base sm:text-lg text-slate-300"
            >
              Join our Discord community and let's bring your ideas to
              life.
            </p>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-join-discord-button"
              className="btn-glow mt-9 inline-flex items-center gap-2 rounded-xl bg-purple-600 hover:bg-purple-500 px-8 py-4 text-base font-semibold text-white shadow-[0_0_30px_rgba(168,85,247,0.5)] hover:shadow-[0_0_45px_rgba(168,85,247,0.75)]"
            >
              Join Our Discord
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
